<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, TabContent, TabPane } from "sveltestrap";
import { error, success } from "../../../../public/my-theme";
import type { Fn } from "../../../global";
import type { Affected } from "../../../Model/Affected";
import type { Third } from "../../../Model/Third";
import { affectedService } from "../../../services";
import AffectedInfoForm from "./AffectedInfoForm.svelte";

  export let affectedThird: Third;
  export let diligenceId: string;
  export let open = false;
  export let toggle: Fn = undefined;

  $: load(diligenceId, affectedThird)

  let size = "lg";
  let affected: Affected;

  const dispatch = createEventDispatcher();

  async function load(diligenceId, affectedThird){
    if (diligenceId && affectedThird) {
      let affecteds: Affected[] = await affectedService.findByDiligenceNumber(diligenceId)
      affected = affecteds.find(c => c.affectedThird == affectedThird.id)
      affected = affected;
    }
  }

  async function saveAffectedTraffic() {
    try {
      save()
      toggle()
      success("Datos guardados con exito");
    } catch (err) {
      error("Comprueba los campos");
    }
  }

  async function changeThirdList(third){
    affected.affectedThird = third.id;
    save()
  }

  async function save(){
    await Promise.all([ 
      affectedService.saveAffected(affected),
    ])

    dispatch('saveAffected');
  }

</script>

<Modal isOpen={open} {toggle} {size}>
  <ModalHeader {toggle}>Editar</ModalHeader>
  <ModalBody>

    <!-- <TabContent> -->
      {#if affected}
        <!-- <TabPane tabId="Datos" tab="Datos" active> -->
            <AffectedInfoForm affected={affected} on:changeThirdLIst={(event) => changeThirdList(event.detail)}/>
        <!-- </TabPane> -->
      {/if}
    <!-- </TabContent> -->

  </ModalBody>
  <ModalFooter>
    <button class="btn btn-success" type="button" on:click={saveAffectedTraffic}>Guardar</button>
  </ModalFooter>
</Modal>

